export class Gender {
    code: string;
    name: string;
}


// WEBPACK FOOTER //
// ./src/app/models/gender.ts